export default "__VITE_ASSET__BYa3YtIh__"